import { Box, Button, Center, Paper, Table, Text, Tooltip } from '@mantine/core';
import { ExternalLink, Play } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import {isActive} from "@tiptap/react";

// One visual for the "#" column, whatever kind of row it belongs to: the chip is
// always centred and the final step is always the orange one.
const StepNumber = ({ step, isFinalStep = false }) => {
    const chip = (
        <Button
            size="compact-sm"
            variant={isFinalStep ? 'filled' : 'light'}
            color={isFinalStep ? 'orange' : 'gray'}
        >
            {step.stepNum}
        </Button>
    );
    return (
        <Table.Td>
            <Center>
                {step.note ? <Tooltip label={step.note}>{chip}</Tooltip> : chip}
            </Center>
        </Table.Td>
    );
};

const VerifyTable = ({ activeStepId, steps, onVerifyRow, user, repo }) => {
  const { t } = useTranslation();

  var rows = [];

  if (steps) {

      rows = steps.map((step, index) => {

          var ret = null;
          const isFinalStep = index === steps.length - 1;

          switch (step.op) {
              case "sha256":
                  ret = <VerifyRow
                          key={index}
                          step={step}
                          isActive={activeStepId === step.id}
                          isFinalStep={isFinalStep}
                          onVerifyRow={onVerifyRow}
                       />;
                  break;

              case "bitcoin":
                  ret = <BitcoinRow key={index} step={step} isFinalStep={isFinalStep} />;
                  break;

              case "server":
                  ret = <ServerRow key={index} step={step} isFinalStep={isFinalStep} />;
                  break;

              case "commit":
              case "fileSha256":
                  ret = <InfoRow key={index} step={step} user={user} repo={repo} isFinalStep={isFinalStep} />;
                  break;

              default:
                  break;
          }
        return ret;
      });
  }

  return (
    <Paper withBorder radius="md" p="md">
      <Box w="100%" overflow="auto">
        <Table withTableBorder withColumnBorders highlightOnHover striped="odd" layout="fixed" w="100%">
          <Table.Thead>
            <Table.Tr>
              <Table.Th w="6%" ta="center">{t('#')}</Table.Th>
              <Table.Th w="27%">{t('Prepend (Left)')}</Table.Th>
              <Table.Th w="30%">{t('Current Result (Middle)')}</Table.Th>
              <Table.Th w="27%">{t('Append (Right)')}</Table.Th>
              <Table.Th w="10%">{t('Action')}</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
      </Box>
    </Paper>
  );
};

const VerifyRow = ({ step, isActive, isFinalStep, onVerifyRow }) => {
  const { t } = useTranslation();
  return (
    <Table.Tr>
      <StepNumber step={step} isFinalStep={isFinalStep} />

      <Table.Td>
        {step.prepend ? (
          <Tooltip label={step.prepend}>
            <Text ff="monospace" size="xs" truncate="end">
              {step.prepend}
            </Text>
          </Tooltip>
        ) : (
          <Text c="dimmed">-</Text>
        )}
      </Table.Td>

      <Table.Td>
        <Tooltip label={step.current}>
          <Text ff="monospace" size="xs" truncate="end">
            {step.current}
          </Text>
        </Tooltip>
      </Table.Td>

      <Table.Td>
        {step.append ? (
          <Tooltip label={step.append}>
            <Text ff="monospace" size="xs" truncate="end">
              {step.append}
            </Text>
          </Tooltip>
        ) : (
          <Text c="dimmed">-</Text>
        )}
      </Table.Td>

      <Table.Td>
        <Button
          size="xs"
          variant={isActive ? 'filled' : 'light'}
          leftSection={<Play size={10} />}
          onClick={() => onVerifyRow(step)}
        >
          {isActive ? t('Loaded') : t('Verify')}
        </Button>
      </Table.Td>
    </Table.Tr>
  );
};


const InfoRow = ({step, user, repo, isFinalStep = false}) => {
    const label = step.op.charAt(0).toUpperCase() + step.op.slice(1);
    const handleView = () => {
        window.open(`https://github.com/${user}/${repo}/tree/${step.current}`, "_blank");
        }
    return <Table.Tr>
                <StepNumber step={step} isFinalStep={isFinalStep} />
                <Table.Td>
                    <Text fw={600} fz="xs">{label}</Text>
                </Table.Td>
                <Table.Td>
                    <Tooltip label={step.current}>
                        <Text ff="monospace" size="xs" truncate="end">
                            {step.current}
                        </Text>
                    </Tooltip>
                </Table.Td>
                <Table.Td></Table.Td>
                <Table.Td>
                    {step.op === "commit" && (
                        <Button size="xs" variant="light" leftSection={<ExternalLink size={12} />} onClick={handleView}>
                            GitHub
                        </Button>
                    )}
                </Table.Td>
            </Table.Tr>;
    }


const BitcoinRow = ({step, isFinalStep = false}) => {
    const handleView = () => {
        window.open(step.link, "bitcoin");
        }
    return <Table.Tr>

                <StepNumber step={step} isFinalStep={isFinalStep} />
                <Table.Td>Bitcoin {step.no}</Table.Td>
                <Table.Td>{step.index}</Table.Td>
                <Table.Td></Table.Td>
                <Table.Td>
                    <Button size={"xs"} variant={"filled"} leftSection={<Play size={10} />} onClick={handleView}>
                        View
                    </Button>
                </Table.Td>

            </Table.Tr>;

    }

const ServerRow = ({step, isFinalStep = false}) => {

    return <Table.Tr>

                <StepNumber step={step} isFinalStep={isFinalStep} />
                <Table.Td>Server</Table.Td>
                <Table.Td>{step.no}</Table.Td>
                <Table.Td></Table.Td>
                <Table.Td></Table.Td>

            </Table.Tr>;

    }

export default VerifyTable;
